export default "__VITE_ASSET__BIMFHXBp__"